export const SITE_NAME = "Ageless";
export const DEFAULT_DESCRIPTION = "Ageless- personalized insights and education.";
